<div class="row ss-top-menu destopSubmit">
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">Dashboard</span>
  </div>
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
    <a class="addCursor float-right downloadBtn" (click)="downloadExcel()">Download Lead</a>
  </div>
</div>
<div class="row">
  <div class="col-12" *ngIf="erroralert">
    <div class="alert-box grid-100" *ngIf="errorMessage">
      <div class="alert alert-danger mt-3 text-center">
        <a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a>
        {{errorMessage}}
      </div>
    </div>
  </div>
  <div class="col-12" *ngIf="successalert">
    <div class="alert-box grid-100" *ngIf="successMessage">
      <div class="alert alert-success mt-3 text-center">
        <a class="close link" data-dismiss="alert"  (click)="successalert=false">×</a>
        {{successMessage}}
      </div>
    </div>
  </div>
</div>
<div class="row p-3">
  <div class="col-md-12 pt-3 pb-3 bg-white">
    <div class="row">
      <div class="col-md-3 mt-3">
        <span class="theme-font">Lead Count by Status</span>
      </div>
      <div class="col-md-9">
        <div class="row">
          <div class="col-md-3">
          </div>
          <div class="col-md-4">
            <span>From:</span>
            <input type="date" name="from_date" class=" form-control from_date ss-date" id="from_date" (change)="changeDateFrom($event.target.value)">
            
          </div>
          <div class="col-md-4">
            <span>To:</span>
            <input type="date" name="to_date" class=" form-control to_date ss-date" id="to_date" (change)="changeDateTo($event.target.value)" min = {{date_from}}>
          </div>
          <!-- <div class="col-md-3">
            <span>Designer:</span>
            <select class="form-control design_partner ss-design_partner" name="design_partner" id="design_partner" (change)="changeDesigner($event.target.value)">
              <option>Select Designer</option>
              <option *ngFor="let designer of my_designers" [value]="designer.id">{{designer.name}} ({{designer.email}})</option>
            </select>
          </div> -->
          <div class="col-md-1 text-center cursor-pointer destopSubmitDiv" style="margin-top: -15px;border-left: 1px solid #ecf0f1;margin-bottom: -15px;" (click)="filterDashboard()" >
            <img src="./assets/img/dashboard/submit.png" style="margin-top: 10px;" class="pt-3 destopSubmit">
            <button class="button mobSubmit" style="margin-top: 10px;">Submit</button>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</div>

<!-- {{usersCount | json}} -->

<div class="row">
  <div class="col-md-4">
    <div class="ss-card p-4 cursor-pointer mt-3" [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: 'leads_total_qualified',designer_id:filter_designer, from_date:date_from, to_date: date_to}" (click)="showDesignerStatusCountRow('leads_total_qualified')">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/qualified_assigned.png">
        </span>
        <span class="theme-font ml-4">
          QUALIFIED
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5">
        <span class="h1">{{usersCount.leads_total_qualified}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> The number of count shows that what number of leads are qualified.</span>
      </div>
    </div>
  </div>



  <div class="col-md-4">
    <div class="ss-card p-4 cursor-pointer mt-3" [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: 'leads_not_assigned',designer_id:filter_designer, from_date:date_from, to_date: date_to}">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/qualified_assigned.png">
        </span>
        <span class="theme-font ml-4">
          NOT ASSIGNED
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5">
        <span class="h1">{{usersCount.leads_not_assigned}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> Total leads that has not been assigned to designers.</span>
      </div>
    </div>
  </div>

  <div class="col-md-4">
    <div class="ss-card p-4 cursor-pointer mt-3" [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: 'leads_dropped',designer_id:filter_designer,from_date:date_from, to_date: date_to}">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/qualified_assigned.png">
        </span>
        <span class="theme-font ml-4">
          DROPPED
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5">
        <span class="h1">{{usersCount.leads_dropped}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> Total leads that has been dropped.</span>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="ss-card p-4 cursor-pointer mt-3"  id="wipbox-activator">
      <div class="ss" [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: 'leads_assigned',designer_id:filter_designer, from_date:date_from, to_date: date_to}">
        <div class="ss-card-head pt-2 pb-4" >
          <span>
            <img src="/assets/img/dashboard/qualified_assigned.png">
          </span>
          <span class="theme-font ml-4">
            ASSIGNED
          </span>
        </div>
        <div class="ss-card-body text-center pt-5 pb-5">
          <span class="h1">{{usersCount.leads_assigned}}</span>
        </div>
        <div class="ss-card-footer pt-4 pb-2">
          <span> Total leads that has been assigned to designers.</span>
          
        </div>
      </div>
      <div class="ss">
        
        <span class="pb-2 pull-right" (click)="showWipList()"><img src="/assets/img/dashboard/info.png"></span>
      </div>
    </div>
    
  </div>



</div>
<div class="row p-3" id="wip-box" >
  <div class="col-md-12 bg-white pt-3 pb-3">
    <div class="row">
      <div class="col-md-3">
        <div class="ss-card p-4 mb-4" style="min-height: 160px; padding-bottom: 0.5rem !important;">
          <div class="ss-card-head pt-2 pb-2">
            <span class="">
              NOT CONTACTABLE
            </span>
            <span class="dashboard-count">{{usersCount.leads_assigned_not_contactable}}</span>
          </div>
          <div class="ss-card-footer pt-3 pb-2">
            <span style="font-size: 11px;"> The number of count shows the data of the leads that are not contactable for some reasons.</span>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="ss-card p-4 mb-4" style="min-height: 160px; padding-bottom: 0.5rem !important;">
          <div class="ss-card-head pt-2 pb-2">
            <span class="">
              LOST
            </span>
            <span class="dashboard-count">{{usersCount.leads_assigned_lost}}</span>
          </div>
          <div class="ss-card-footer pt-3 pb-2">
            <span style="font-size: 11px;"> The number of count shows the leads which cannot be further pursued.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="ss-card p-4 mb-4" style="min-height: 160px; padding-bottom: 0.5rem !important;">
          <div class="ss-card-head pt-2 pb-2">
            <span class="">
              WIP
            </span>
            <span class="dashboard-count">{{usersCount.leads_assigned_after_wip}}</span>
          </div>
          <div class="ss-card-footer pt-3 pb-2">
            <span style="font-size: 11px;"> The number of count shows the data of the leads that are in WIP.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="ss-card p-4 mb-4" style="min-height: 160px; padding-bottom: 0.5rem !important;">
          <div class="ss-card-head pt-2 pb-2">
            <span class="">
              FOLLOW UP
            </span>
            <span class="dashboard-count">{{usersCount.leads_assigned_follow_up}}</span>
          </div>
          <div class="ss-card-footer pt-3 pb-2">
            <span style="font-size: 11px;"> The number of count shows that how many leads needed to be followed up on.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 


<div class="row p-3 mt-4">
  <div class="col-md-12 pt-3 pb-3 bg-white">
    <div class="row">
      <div class="col-md-8">
        <span class="theme-font">Lead Count by Assigned Designer Status</span>
      </div>
      <div class="col-md-4">
        
      </div>
    </div>
  </div>
</div>

<!-- <div class="row">
  <div class="col-md-4">
    <div class="ss-card p-4 cursor-pointer mt-3" [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: 'leads_assigned_qualified'}">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/qualified_assigned.png">
        </span>
        <span class="theme-font ml-4">
          ACTION PENDING
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5">
        <span class="h1">{{usersCount.leads_assigned_qualified}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> Action pending on leads by designers.</span>
      </div>
    </div>
  </div>

  <div class="col-md-4">
    <div class="ss-card p-4 cursor-pointer mt-3" [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: 'leads_assigned_lost'}">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/qualified_assigned.png">
        </span>
        <span class="theme-font ml-4">
          LOST
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5">
        <span class="h1">{{usersCount.leads_assigned_lost}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> Total leads lost.</span>
      </div>
    </div>
  </div>

  <div class="col-md-4">
    <div class="ss-card p-4 cursor-pointer mt-3" [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: 'leads_assigned_follow_up'}">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/qualified_assigned.png">
        </span>
        <span class="theme-font ml-4">
          FOLLOW UP
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5">
        <span class="h1">{{usersCount.leads_assigned_follow_up}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> Total leads that are in follow up status.</span>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-4">
    <div class="ss-card p-4 cursor-pointer mt-3" [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: 'leads_assigned_not_contactable'}">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/qualified_assigned.png">
        </span>
        <span class="theme-font ml-4">
          NOT CONTACTABLE
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5">
        <span class="h1">{{usersCount.leads_assigned_not_contactable}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> Total leads which are in not contactable status.</span>
      </div>
    </div>
  </div>

  <div class="col-md-4">
    <div class="ss-card p-4 cursor-pointer mt-3" id="wipbox-activator" (click) = "showWip()" >
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/qualified_assigned.png">
        </span>
        <span class="theme-font ml-4">
          WIP
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5">
        <span class="h1">{{usersCount.leads_assigned_wip}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> Total leads which are in WIP status.</span>
      </div>
    </div>
  </div>

  <div class="col-md-4">
    <div class="ss-card p-4 cursor-pointer mt-3 mb-5" [routerLink]="['/designer/leads']" routerLinkActive="active" [queryParams]="{customer_status: 'dropped'}">
      <div class="ss-card-head pt-2 pb-4">
        <span>
          <img src="/assets/img/dashboard/qualified_assigned.png">
        </span>
        <span class="theme-font ml-4">
          HANDOVER
        </span>
      </div>
      <div class="ss-card-body text-center pt-5 pb-5">
        <span class="h1">{{usersCount.leads_assigned_handover}}</span>
      </div>
      <div class="ss-card-footer pt-4 pb-2">
        <span> Total leads which are handed over.</span>
      </div>
    </div>
  </div>
</div> -->

<div class="row cm-designers-actionables">
  <div class="col-sm-12" *ngIf="usersCount.designer_data && usersCount.designer_data.length > 0">
    <div class="tableDiv">
      <div class="table-responsive">
        <table class="table">
          <thead class="thead-dark">
            <tr>
              <th class="firstTh">#</th>
              <th>Designer</th>
              <th>Action Pending</th>
              <th>Lost</th>
              <th>Follow Up</th>
              <th>Not Contactable</th>
              <th>WIP</th>
              <th class="lastTh">Handover</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let descount of usersCount.designer_data; let m=index; ">
              <td>{{m+1}}</td>
              <td>{{descount.name}} - {{descount.email}}</td>
              <td class="text-center"><a [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: 'leads_assigned_qualified','designer_id':descount.id, 'from_date': date_from,'to_date': date_to}">{{descount.actionable_count.qualified || 0}}</a></td>

              <td class="text-center"><a [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: 'leads_assigned_lost','designer_id':descount.id, 'from_date': date_from,'to_date': date_to}">{{descount.actionable_count.lost || 0 }}</a></td>

              <td class="text-center"><a [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: 'leads_assigned_follow_up','designer_id':descount.id, 'from_date': date_from,'to_date': date_to}">{{descount.actionable_count.follow_up || 0}}</a></td>

              <td class="text-center"><a [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: 'leads_assigned_not_contactable','designer_id':descount.id, 'from_date': date_from,'to_date': date_to}">{{descount.actionable_count.not_contactable || 0}}</a></td>

              <td class="text-center"><a class="addCursor" (click) = "showWip(m)">{{descount.actionable_count.wip || 0}}</a></td>

              <td class="text-center"><a [routerLink]="['/designer/leads']" routerLinkActive="active" [queryParams]="{customer_status: 'dropped'}" (click)="changeDesigner(descount.id)">{{descount.actionable_count.handover || 0}}</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="col-sm-12" *ngIf="!usersCount.designer_data">
    loading data...
  </div>

</div>



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/organisation/cm-dashboard/cm-dashboard.component.html